var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    x1: 99.8,
    y1: 115.96,
    x2: 99.8,
    y2: 140.3,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.11,
    y1: 140.3,
    x2: 115.11,
    y2: 91.62,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.43,
    y1: 91.62,
    x2: 130.43,
    y2: 140.3,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.43,
    y1: 66.27,
    x2: 130.43,
    y2: 91.62,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.11,
    cy: 24.11,
    r: 14.41,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,52.78a9.38,9.38,0,0,1,9.06-7h36.12a9.38,9.38,0,0,1,9.38,9.38V91.62",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.02,
    y1: 91.62,
    x2: 130.43,
    y2: 91.62,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.57,
    y1: 61.11,
    x2: 19.57,
    y2: 140.3,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.89,
    y1: 140.3,
    x2: 34.89,
    y2: 91.62,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.2,
    y1: 117.1,
    x2: 50.2,
    y2: 140.3,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.89,
    cy: 24.11,
    r: 14.41,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45,91.62V55.21a9.38,9.38,0,0,1,9.38-9.38H53",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.57,
    y1: 91.62,
    x2: 38.15,
    y2: 91.62,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32,58.23c-2.41,1.36-5.49,2.32-8.8,4.45a29,29,0,0,0-10.2,12,31.24,31.24,0,0,0-.74,24.77",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "66.38 53.44 71.55 52.26 72.73 57.43",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.86,110.74c2.29,1.41,4.61,3.49,8,5.22a28.94,28.94,0,0,0,15.48,2.84,31.24,31.24,0,0,0,21.82-11.74",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "49.4 112.92 45.79 109.03 49.68 105.42",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.3,94.65a76.81,76.81,0,0,0,.52-9.07,28.92,28.92,0,0,0-5.29-14.82,31.23,31.23,0,0,0-21.07-13",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "109.4 97.88 107.83 102.95 102.77 101.38",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,73.78h0A39,39,0,0,1,44.65,54.7l5.08-2.44H26Z",
    style: {
      fill: "#223773"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.42,73.78h0A39,39,0,0,0,105.77,54.7l-5.07-2.44h23.72Z",
    style: {
      fill: "#223773"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 87.51,
    r: 13.03,
    transform: "translate(-19.9 152.9) rotate(-83.97)",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.54,63.09H73.46A2.46,2.46,0,0,0,71,65.56h0a2.47,2.47,0,0,1-1.76,2.37,20.22,20.22,0,0,0-4,1.65,2.49,2.49,0,0,1-2.93-.43h0a2.47,2.47,0,0,0-3.5,0l-2.17,2.17a2.48,2.48,0,0,0,0,3.51h0a2.47,2.47,0,0,1,.43,2.92,20.34,20.34,0,0,0-1.66,4,2.45,2.45,0,0,1-2.36,1.75h0A2.48,2.48,0,0,0,50.58,86V89a2.48,2.48,0,0,0,2.48,2.48h0a2.45,2.45,0,0,1,2.36,1.76,20.51,20.51,0,0,0,1.66,4,2.47,2.47,0,0,1-.43,2.92h0a2.48,2.48,0,0,0,0,3.51l2.17,2.17a2.47,2.47,0,0,0,3.5,0h0a2.49,2.49,0,0,1,2.93-.43,20.22,20.22,0,0,0,4,1.65A2.47,2.47,0,0,1,71,109.45h0a2.47,2.47,0,0,0,2.47,2.48h3.08A2.47,2.47,0,0,0,79,109.45h0a2.47,2.47,0,0,1,1.76-2.37,20.22,20.22,0,0,0,4-1.65,2.49,2.49,0,0,1,2.93.43h0a2.47,2.47,0,0,0,3.5,0l2.17-2.17a2.48,2.48,0,0,0,0-3.51h0a2.47,2.47,0,0,1-.43-2.92,20.51,20.51,0,0,0,1.66-4,2.45,2.45,0,0,1,2.36-1.76h0A2.48,2.48,0,0,0,99.42,89V86a2.48,2.48,0,0,0-2.48-2.48h0a2.45,2.45,0,0,1-2.36-1.75,20.34,20.34,0,0,0-1.66-4,2.47,2.47,0,0,1,.43-2.92h0a2.48,2.48,0,0,0,0-3.51l-2.17-2.17a2.47,2.47,0,0,0-3.5,0h0a2.49,2.49,0,0,1-2.93.43,20.22,20.22,0,0,0-4-1.65A2.47,2.47,0,0,1,79,65.56h0A2.46,2.46,0,0,0,76.54,63.09Z",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e7bf625eb44a84fcb8343935c8f55067.svg";
export { ForwardRef as ReactComponent };